import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { brokerApi } from '@api/broker/broker.api';
import { BrokerOnboarding } from '@api/broker/types';
import { useAuth } from '@providers/AuthProvider/AuthContext';
export const BROKER_ONBOARDING_QUERY_KEY = 'broker-onboarding';

export const useBrokerOnboarding = (): UseQueryResult<BrokerOnboarding> => {
  const { isSignedIn, isLoaded } = useAuth();
  const enabled = isSignedIn && isLoaded;

  return useQuery([BROKER_ONBOARDING_QUERY_KEY], brokerApi.getOnboarding, { enabled, refetchOnWindowFocus: false });
};
